import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GetTariffsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tariffs/models/inputs/get-tariffs-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterTariffListContext } from '../../tariff.context';
import { TariffListFilterFormStep1Controller } from '../tariff-list-filter-form-step-1/tariff-list-filter-form-step-1.controller';

export interface TariffListFilterFormControllerProps {
  onError: SubmitErrorHandler<GetTariffsPaginatedModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GetTariffsPaginatedModel>;
  onCancel: () => void;
}

export const TariffListFilterFormController = (
  props: TariffListFilterFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel } = props;
  const data = useFilterTariffListContext();

  return (
    <MultiStepFormProvider<GetTariffsPaginatedModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      items={[
        {
          fields: ['type'],
          component: <TariffListFilterFormStep1Controller />,
        },
      ]}
    />
  );
};
